<div class="footer-bar" role="contentinfo">
  <p>{{ "footer.printtitle" | translate }}</p>
  <div class="footer-bar-paginate">
    <span>Page {{pageNumber}}</span>
    <!-- <span>Page <span class="pagenumber">3</span> of <span class="pagecount">3</span></span> -->
  </div>
</div>
<P style="page-break-before: always"></P>